document.addEventListener("DOMContentLoaded", function () {
  if (typeof applyColorDictionary === 'function') {
    applyColorDictionary();
  }

  const variantColors = document.querySelectorAll(".variant-color");
  const containerVariant = document.querySelector(".container-variant-color");
  const titleVariant = document.getElementById("titleVariant");
  const titleVariantSpan = titleVariant?.querySelector("span");

  if (variantColors.length > 0 && titleVariantSpan) {
    variantColors.forEach(element => {
      element.addEventListener("mouseover", function () {
        const colorName = this.getAttribute("data-name-color");
        if (colorName) {
          titleVariantSpan.textContent = colorName;
        }
      });
    });

    if (containerVariant && titleVariant) {
      containerVariant.addEventListener("mouseleave", function () {
        const originalColorName = titleVariant.getAttribute("data-name-color");
        if (originalColorName) {
          titleVariantSpan.textContent = originalColorName;
        }
      });
    }
  }
});

function applyColorDictionary() {
  const colorDict = window.colorDictionary || {};
  const variantColors = document.querySelectorAll(".variant-color");
  const titleVariant = document.getElementById("titleVariant");
  const titleVariantSpan = titleVariant?.querySelector("span");

  if (variantColors.length === 0) return;

  const titleColor = titleVariant?.getAttribute("data-color")?.trim().toUpperCase();

  variantColors.forEach(element => {
    const colorCode = element.getAttribute("data-color")?.trim().toUpperCase();
    if (!colorCode) return;

    // Buscar nombre del color (case-insensitive)
    const colorName = colorDict[colorCode]?.name || 
                      Object.entries(colorDict).find(([key]) => 
                        key.toUpperCase() === colorCode
                      )?.[1]?.name || 
                      colorCode;

    element.setAttribute("data-name-color", colorName);

    // Actualizar título si coincide el color
    if (titleVariant && titleVariantSpan && titleColor === colorCode) {
      titleVariant.setAttribute("data-name-color", colorName);
      titleVariantSpan.textContent = colorName;
    }
  });
}